var _stop, _stop2, _stop3, _stop4, _stop5, _stop6, _stop7, _stop8, _stop9, _stop10, _stop11, _stop12, _stop13, _stop14, _stop15, _stop16, _stop17, _stop18, _stop19, _stop20, _stop21, _stop22, _stop23, _stop24, _stop25, _stop26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgAudioWaves(props) {
  const _id13 = useUniqueInlineId();
  const _id12 = useUniqueInlineId();
  const _id11 = useUniqueInlineId();
  const _id10 = useUniqueInlineId();
  const _id9 = useUniqueInlineId();
  const _id8 = useUniqueInlineId();
  const _id7 = useUniqueInlineId();
  const _id6 = useUniqueInlineId();
  const _id5 = useUniqueInlineId();
  const _id4 = useUniqueInlineId();
  const _id3 = useUniqueInlineId();
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#".concat(_id, ")"),
    strokeWidth: 2,
    d: "M1 10v18"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#".concat(_id2, ")"),
    strokeWidth: 2,
    d: "M8 6v26"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#".concat(_id3, ")"),
    strokeWidth: 2,
    d: "M15 0v38"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#".concat(_id4, ")"),
    strokeWidth: 2,
    d: "M22 6v26"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#".concat(_id5, ")"),
    strokeWidth: 2,
    d: "M29 10v18"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#".concat(_id6, ")"),
    strokeWidth: 2,
    d: "M36 6v26"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#".concat(_id7, ")"),
    strokeWidth: 2,
    d: "M43 0v38"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#".concat(_id8, ")"),
    strokeWidth: 2,
    d: "M50 6v26"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#".concat(_id9, ")"),
    strokeWidth: 2,
    d: "M57 10v18"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#".concat(_id10, ")"),
    strokeWidth: 2,
    d: "M64 6v26"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#".concat(_id11, ")"),
    strokeWidth: 2,
    d: "M71 0v38"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#".concat(_id12, ")"),
    strokeWidth: 2,
    d: "M78 6v26"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#".concat(_id13, ")"),
    strokeWidth: 2,
    d: "M85 10v18"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 0.177,
    y1: 16.007,
    x2: -0.938,
    y2: 15.968,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#FF3C27"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 7.177,
    y1: 14.677,
    x2: 6.061,
    y2: 14.65,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#FF3C27"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id3,
    x1: 14.177,
    y1: 12.682,
    x2: 13.06,
    y2: 12.664,
    gradientUnits: "userSpaceOnUse"
  }, _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1"
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#FF3C27"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id4,
    x1: 21.177,
    y1: 14.677,
    x2: 20.061,
    y2: 14.65,
    gradientUnits: "userSpaceOnUse"
  }, _stop7 || (_stop7 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1"
  })), _stop8 || (_stop8 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#FF3C27"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id5,
    x1: 28.177,
    y1: 16.007,
    x2: 27.061,
    y2: 15.968,
    gradientUnits: "userSpaceOnUse"
  }, _stop9 || (_stop9 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1"
  })), _stop10 || (_stop10 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#FF3C27"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id6,
    x1: 35.177,
    y1: 14.677,
    x2: 34.061,
    y2: 14.65,
    gradientUnits: "userSpaceOnUse"
  }, _stop11 || (_stop11 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1"
  })), _stop12 || (_stop12 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#FF3C27"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id7,
    x1: 42.177,
    y1: 12.682,
    x2: 41.06,
    y2: 12.664,
    gradientUnits: "userSpaceOnUse"
  }, _stop13 || (_stop13 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1"
  })), _stop14 || (_stop14 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#FF3C27"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id8,
    x1: 49.177,
    y1: 14.677,
    x2: 48.061,
    y2: 14.65,
    gradientUnits: "userSpaceOnUse"
  }, _stop15 || (_stop15 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1"
  })), _stop16 || (_stop16 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#FF3C27"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id9,
    x1: 56.177,
    y1: 16.007,
    x2: 55.062,
    y2: 15.968,
    gradientUnits: "userSpaceOnUse"
  }, _stop17 || (_stop17 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1"
  })), _stop18 || (_stop18 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#FF3C27"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id10,
    x1: 63.177,
    y1: 14.677,
    x2: 62.061,
    y2: 14.65,
    gradientUnits: "userSpaceOnUse"
  }, _stop19 || (_stop19 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1"
  })), _stop20 || (_stop20 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#FF3C27"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id11,
    x1: 70.177,
    y1: 12.682,
    x2: 69.061,
    y2: 12.664,
    gradientUnits: "userSpaceOnUse"
  }, _stop21 || (_stop21 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1"
  })), _stop22 || (_stop22 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#FF3C27"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id12,
    x1: 77.177,
    y1: 14.677,
    x2: 76.061,
    y2: 14.65,
    gradientUnits: "userSpaceOnUse"
  }, _stop23 || (_stop23 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1"
  })), _stop24 || (_stop24 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#FF3C27"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id13,
    x1: 84.177,
    y1: 16.007,
    x2: 83.061,
    y2: 15.968,
    gradientUnits: "userSpaceOnUse"
  }, _stop25 || (_stop25 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1"
  })), _stop26 || (_stop26 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#FF3C27"
  })))));
}
export default SvgAudioWaves;